import { useMemo } from 'react';
import { formatLocalTime } from '../services/helpers';

const useFirstPickupPhoto = (pickup_photos, serverTimezone) => useMemo(() => {
  if (!pickup_photos?.length) return '-';

  const firstPhoto = [...pickup_photos].sort((p1, p2) => p1.id - p2.id)[0];

  return formatLocalTime({
    entity: firstPhoto,
    serverTimezone,
    format: 'D MMM YYYY hh:mm A zz',
  });
}, [pickup_photos, serverTimezone]);

export default useFirstPickupPhoto;
